export default __webpack_public_path__ + "img/Recent_blue.f888a2f9.svg";